import React from 'react';
import styled from 'styled-components';
import checkbox_ic from './checkbox.svg';
import checkbox_active_ic from './checkbox-active.svg';
import shopSelectors from 'services/shop/selectors';
import { Form } from 'antd';

const DepositCancellationPolicy = () => {
  const settingDeposit = shopSelectors.data.settingDepositBooking();

  if (!settingDeposit?.active) return null;

  return (
    <Container>
      <div className="policy-container">
        <p className="title">Cancellation Policy</p>
        <p className="content">
          Beauty HD Salon asks for a <b>2-hour</b> cancellation or rescheduling notice for cuts and <b>72 hour</b> for color appointments or chemical services. We will <b>charge 50%</b> for the first missed appointment, and 100% for anytime after that.
        </p>
      </div>
      <Form.Item name={'acceptPolicyDeposit'} noStyle>
      <PolicyCheckbox />
      </Form.Item>
    </Container>
  );
};

export default DepositCancellationPolicy;

const Container = styled.div`
display: flex;
flex-direction: column;
align-items: center;
gap: 16px;
align-self: stretch;
padding: 8px 0px;

.policy-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  p.title {
    align-self: stretch;
    color: #505050;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.32px;
  }

  p.content {
    color: #1D2129;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px; /* 150% */
    letter-spacing: 0.28px;

    b {
      color: #1D2129;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 21px;
      letter-spacing: 0.32px;
    }
  }
}
`;

type PolicyCheckboxProps = {
  value?: boolean;
  onChange?: (value: boolean) => void;
};

const PolicyCheckbox = ({ value, onChange }: PolicyCheckboxProps) => {
  const settingDeposit = shopSelectors.data.settingDepositBooking();

  if (!settingDeposit?.active) return null;

  return (
    <PolicyCheckboxContainer type='button' onClick={() => onChange?.(!value)}>
      <img src={value ? checkbox_active_ic : checkbox_ic} alt="checkbox_active_ic" />
      <span>By clicking Pay, you agree to the Cancellation Policy and conditions of this business</span>
    </PolicyCheckboxContainer>
  );
};

const PolicyCheckboxContainer = styled.button`
display: flex;
align-items: flex-start;
gap: 8px;
align-self: stretch;

img {
  width: 32px;
  height: 32px;
  aspect-ratio: 1/1;
}
span {
  text-align: left;
  color: #1D2129;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 137.5%; /* 19.25px */
  letter-spacing: 0.28px;
}
`;